export const companyInputs = [
  'main-name',
  'industryId',
  'contact-address',
  'contact-phoneNumber',
  'contact-email',
  'main-taxNumber',
  'countryCode',
  'currency',
]

export const companiesInitialState = {
  name: '',
  industryId: null,
  industry: { name: null, id: null },
  contact: {
    address: '',
    email: '',
    phoneNumber: '+',
  },
  taxNumber: '',
  settings: {
    shouldIncludeTraffic: false,
    currency: null,
  },
}
